import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Amplify, { Auth, Storage } from "aws-amplify";
import InfiniteScroll from 'react-infinite-scroll-component';
import VideoListCell from './VideoListCell';

class VideoList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loaderText: "Loading...",
      profile: null,
      fileID:null,
      username: null,
      height: 0,
      items: []
    };
  }

  componentDidMount() {
    this.setState({
      height: this.props.height,
    });
    console.log("height of VideoList is " + this.props.height);

    if (this.props.auth.selectedVideoID !== null) {
      this.setState({
        fileID: this.props.auth.selectedVideoID
      }, () => {
        this.props.auth.setSelectedVideoID(null);
        this.setVideoList();
      });
    } else {
      this.setVideoList();
    }

  }

  setVideoList = async event => {

    const profile = this.props.auth.getUserProfile();
    if (profile.username === null) {
      await this.props.auth.setUserProfile();
    }
    this.setState({
      profile: this.props.auth.getUserProfile()
    }, () => {
      this.checkUsername()
      this.getVideoList()
    })
  }

  checkUsername = async event => {
    console.log("VideoList [checkUsername] username: " + JSON.stringify(this.state.profile));
    if (this.props.username) {
      this.setState({
        username: this.props.username
      });
    }
  }

  videoSelected = async fileID => {
    console.log("[videoSelected] fileID: " + fileID);
    if (this.props.videoView) {
      this.props.videoView.setState({
        fileID: fileID
      }, ()=> {
        this.props.videoView.setVideo()
      });
    } else {
      // OPEN WatchVideo view
      console.log("OPEN WatchVideo with " + fileID);
      await this.props.auth.setSelectedVideoID(fileID);
      this.props.history.push("/watchvideo");
    }
  }

  fetchMoreData = () => {
    // a fake async api call like which sends
    // 20 more records in 1.5 secs
    /*
    setTimeout(() => {
      this.setState({
        items: this.state.items.concat(Array.from({ length: 20 }))
      });
    }, 1500);

    */
  };

  getVideoList = () => {
    console.log("[getVideoList]");
    const ApiUrl = "https://ljnrpe322d.execute-api.us-east-1.amazonaws.com/prod/service";

    return fetch(ApiUrl, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.json())

    .then((responseJson) => {
      console.log("responseJson: " + JSON.stringify(responseJson));

      var items = responseJson["body"].Items;
      console.log('items: ' + JSON.stringify(items));


      // filter out videos not in the presetList
      if (this.props.presetList && this.props.presetList.length > 0) {
        console.log("this.props.presetList: " + this.props.presetList + " and the length is " + this.props.presetList.length);
        const allItems = items;
        var newItems = [];
        for (var i = 0; i<this.props.presetList.length; i++) {
          const item = this.props.presetList[i];
          for (var j = 0; j<allItems.length; j++) {
            const userItem = allItems[j];
            console.log("item: " + item + " userItem: " + userItem.fileID);
            if (userItem.fileID === item) {
              newItems.push(userItem);
            }
          }
        }
        items = newItems;
        console.log("items: " + JSON.stringify(items));
      } else {
        /*
        items = [];
        this.setState({
          loaderText: "The list is currently empty."
        })
        */
      }

      this.setState({
        items: items
      }, () => {

        if (this.props.videoView !== null) {
          // WatchVideo page
          if (this.state.fileID) {
            this.props.videoView.setState({
              fileID: this.state.fileID
            }, () => {
              this.props.videoView.setVideo();
            });
          } else {
            // profile page
          }
        }
      });
    })
    .catch((error) => {
      console.log("ERROR [getUserID]: " + JSON.stringify(error));
    });
  }

  render() {
    return(
      <div className="video-list-container">
      <InfiniteScroll
        dataLength={this.state.items.length}
        next={this.fetchMoreData}
        hasMore={true}
        loader={<h4>{this.state.loaderText}</h4>}
        height={this.props.height}
      >
        {this.state.items.map((i, index) => (
          <VideoListCell videoList={this} auth={this.props.auth} item={i} key={index} />
        ))}
      </InfiniteScroll>
      </div>
    )
  }

}

export default withRouter(VideoList);
